// style rules for CallTextSettingEditor and for EmailSettingEditor
const PLAIN_WIDTH = 550 // px
const RICH_WIDTH = 550 // px

const rooster = {
  container: {
    backgroundColor: '#f0f0f0',
    border: '1px solid grey',
    borderRadius: '5px',
    boxShadow: '10px 10px 20px 0px rgba(0,0,0,0.11)',
    display: 'flex',
    flexDirection: 'column',
    maxHeight: '93vh',
    minHeight: '250px',
    overflow: 'auto',
    padding: '15px',
    resize: 'vertical',
    width: `${PLAIN_WIDTH}px`,
  },
  richContainer: {
    width: `${RICH_WIDTH}px`,
    minHeight: '400px',
  },
  buttonArea: {
    display: 'flex',
    justifyContent: 'flex-start',
    position: 'relative',
    padding: '6px 4px 0px 4px',
    flexShrink: 0,
  },
  button_primary: {
    position: 'relative',
  },
  button_secondary: {
    position: 'relative',
  },
  textbox_custom: {
    color: 'black',
    borderColor: '#1672fb',
  },
  nameField: {
    backgroundColor: 'white',
  },
  plainTextEditorContainer: {
    backgroundColor: 'white',
    border: '1px solid #ccc',
    // borderRadius: '5px',
    minHeight: '30px',
  },
  minHeight100px: {
    minHeight: '100px',
    flexGrow: 2,
    height: '50%',
  },
  settingsEmailBody: {
    borderRadius: '5px',
    height: '100%',
    overflow: 'auto',
    padding: '0 10px',
  },
}

const tops = {
  container: {
    boxShadow: '10px 10px 20px 0px rgba(0,0,0,0.11)',
    position: 'relative',
    backgroundColor: '#f0f0f0',
    width: '550px',
    borderRadius: '5px',
    padding: '15px',
    border: '1px solid #333',
    resize: 'vertical',
    display: 'flex',
    flexDirection: 'column',
    minHeight: '250px',
    maxHeight: '98vh',
  },
  richContainer: {
    width: `${RICH_WIDTH}px`,
    minHeight: '400px',
  },
  description: {
    textAlign: 'right',
    fontSize: '0.9em',
    color: '#1672fb',
    fontWeight: 'bold',
  },
  blank_description: {
    fontWeight: 'bold',
  },
  offset: {
    fontWeight: 'bold',
  },
  buttonArea: {
    display: 'flex',
    justifyContent: 'flex-start',
    position: 'relative',
    padding: '10px 12px 0px 0px',
    flexShrink: 0,
  },
  button_primary: {
    color: '#1672fb',
    position: 'relative',
  },
  button_secondary: {
    position: 'relative',
  },
  textbox_custom: {
    color: 'black',
    borderColor: '#1672fb',
  },
  nameField: {
    backgroundColor: 'white',
  },
  plainTextEditorContainer: {
    backgroundColor: 'white',
    border: '1px solid grey',
    borderRadius: '5px',
    position: 'relative',
    minHeight: '30px',
  },
  minHeight100px: {
    minHeight: '100px',
    flexGrow: 2,
    height: '50%',
  },
}

module.exports = process.env.REACT_APP_IS_TOPS ? tops : rooster



// WEBPACK FOOTER //
// ./src/components/Settings/styles/SettingEditor.js